import { render, staticRenderFns } from "./file-name.vue?vue&type=template&id=e1b4ede2&scoped=true&"
import script from "./file-name.vue?vue&type=script&lang=ts&"
export * from "./file-name.vue?vue&type=script&lang=ts&"
import style0 from "./file-name.vue?vue&type=style&index=0&id=e1b4ede2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b4ede2",
  null
  
)

export default component.exports